import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { cargarInformeSemanalAsync } from "./cargarInformeSemanal";
import { buildReporteMonitoreoHtml } from "./reporteMonitoreoDocument";

/** Margen antes de revocar la URL del blob. La pestaña ya cargó el documento
 *  mucho antes, pero revocar de inmediato corre una carrera con navegadores que
 *  todavía no terminaron de abrirla. */
const REVOKE_DELAY_MS = 60_000;

/**
 * Abre el informe imprimible de una semana en una pestaña nueva y dispara ahí
 * el diálogo de impresión.
 *
 * Recibe **todas las sesiones de la semana**, no una: el monitoreo se reparte
 * en varias salidas y el informe de una sola mostraría los lotes de ese
 * recorrido nada más.
 *
 * La pestaña se abre **antes** de las peticiones: si se abriera después, el
 * `window.open` ya no estaría dentro del gesto del usuario y el bloqueador de
 * ventanas emergentes lo cancelaría.
 *
 * @param sesionIds Sesiones de la semana a informar.
 */
export async function openReporteMonitoreo(sesionIds: string[]): Promise<void> {
  const errorService = serviceProvider.getErrorService();
  if (sesionIds.length === 0) return;

  const pestana = window.open("", "_blank");
  if (!pestana) {
    errorService.addWarning(
      "Reporte de monitoreo",
      "El navegador bloqueó la ventana emergente. Habilite las ventanas emergentes para este sitio y vuelva a intentarlo.",
    );
    return;
  }

  pestana.document.write(
    "<!DOCTYPE html><html lang='es'><head><meta charset='UTF-8'><title>Generando reporte…</title></head><body style=\"font-family:system-ui;padding:24px;color:#5c5b56\">Generando el reporte…</body></html>",
  );
  pestana.document.close();

  try {
    const { informe, plagas, poligonos } = await cargarInformeSemanalAsync(sesionIds);

    // El usuario pudo cerrar la pestaña mientras cargaban los datos.
    if (pestana.closed) return;

    // `autoImprimir`: la pestaña abre el diálogo de impresión sola, y ahí el
    // usuario elige "Guardar como PDF" o una impresora. El documento conserva
    // igual su botón "Exportar PDF" para volver a abrirlo.
    const html = buildReporteMonitoreoHtml(informe, plagas, {
      autoImprimir: true,
      poligonos,
    });
    const url = URL.createObjectURL(
      new Blob([html], { type: "text/html;charset=utf-8" }),
    );
    pestana.location.replace(url);
    window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
  } catch {
    if (!pestana.closed) pestana.close();
    errorService.addError(
      "Reporte de monitoreo",
      "No se pudo generar el reporte de la semana.",
    );
  }
}
